<template>
  <div class="mylocal__postcode-container" v-if="showPostcode">
    <div class="mylocal__postcode">
      <h4 class="mylocal__postcode-heading">
        <div class="mylocal__branding">
         {{name}}
        </div>
      </h4>
      <form class="mylocal__postcode-form" @submit.prevent="processForm">
        <div class="mylocal__postcode-title" v-if="!isPrefAvailable">
          CUSTOMISE YOUR LOCAL NEWS
        </div>
        <input 
          class="mylocal__postcode-input"
          type="text" 
          v-model="inputPostcode" 
          maxlength="20"
          name="mylocal-postcode-field"
          id="mylocal-postcode-field"
          v-on:input="handleOnChange"
          autocomplete="off"
          size="4"/>
        <label class="mylocal__postcode-placeholder" for="mylocal-postcode-field" v-if="!inputPostcode.length > 0">
          <div class="mylocal__postcode-placeholder-text">
            <span>Enter Suburb...</span>
            <span>To Update News</span>
          </div>
          <ToolTip :isPrefAvailable="true"/>
        </label >

        <button 
          type="submit"
          class="mylocal__postcode-button">
            <span>Go</span>
        </button>
        <div class="mylocal__postcode-dropdown" v-if="foundMatchedLocals">
          <ul class="mylocal__postcode-dropdown-list" v-if="matchedLocals.length > 0">
            <li 
              v-bind:key="item.index" 
              v-for="(item, index) in matchedLocals">
              <a href="" @click="handleSelectLocal(index, $event)">{{item.localName}}</a>
            </li>
          </ul>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import masthead from '../assets/postcode/masthead.json';
import { PRODUCT_MAP } from '../config/api.config';
import suburbsJson from '../assets/postcode/suburbs.json';
// import { getNearbySuburbs } from '../logic/location';

import ToolTip from './ToolTip.vue';

export default {
  name: 'PostCode',
  props: {
    name: String,
    homeLink: String,
    isPrefAvailable: Boolean,
    showPostcode: Boolean
  },
  components: {
    ToolTip
  },
  data () {
    return {
      inputPostcode: '',
      matchedLocals: [],
      selectedLocal: {}
    }
  },
  computed: {
    foundMatchedLocals() {
      return (this.inputPostcode.length >= 3 && this.matchedLocals.length > 0);
    },
    foundUnmatchedLocals() {
      return (this.inputPostcode.length >= 3 && this.matchedLocals.length === 0);
    }
  },
  methods: {
    handleOnChange() {
      if (this.inputPostcode.length >= 3) {
        const suburb = this.inputPostcode.toLowerCase();

        const getMatchedSubs = suburbsJson.reduce((acc, item) => {
          const thisSub = item[1].toLowerCase();
          const isMatchedPostcode = item[0] === suburb;
          const productName = this.globalConfig.productName.toLowerCase();
          const state = PRODUCT_MAP[productName].state;
          const targetDomain = PRODUCT_MAP[productName].targetDomain;
          const currentState = item[2] === 'ACT' ? 'NSW' : item[2];

          const isMatched = currentState === state && (isMatchedPostcode || thisSub.indexOf(suburb) > -1); 
          
          const matchedLocal = {
            productName: this.globalConfig.productName,
            targetDomain,
            localName: item[1],
            state: item[2],
            coord: {lat: item[3], long: item[4]},
            postcode: item[0]
          };
          
          const uniqueId = `${state}-${item[1]}`;
          const hasValidPostcode = acc[uniqueId] && acc[uniqueId].postcode > item[0];
          
          if (!hasValidPostcode && isMatched) {
            acc[uniqueId] = matchedLocal;
          }

          return acc;
        }, {});

        this.matchedLocals = Object.values(getMatchedSubs);
      }
    },

    resetInput() {
      this.inputPostcode = '';
    },

    handleGetTheBestOf() {
      this.$emit('handleGetTheBestOf');
      this.resetInput();
    },

    handleGetLocalByCategoryId(selectedLocal) { // No longer used
      this.$emit('handleUpdateByMasthead', selectedLocal);

      this.resetInput();
    },

    handleSelectLocal(index, e) {
      e.preventDefault();
      
      this.selectedLocal = this.matchedLocals[index];

      // *****************************************************
      // This snippet helps to split the predefined masthead postcode v undefined ones.
      // Temporarily we decided to use undefined postcodes only to call for suburbs.
      // TO-DO: Remove all predefined masthead postcodes or having better strategies to pull content for users.

      // const selectedPostcode = this.selectedLocal.postCode;
      // const matchedMasthead = matchedMastheadPostcode(selectedPostcode, this.globalConfig.productName);

      // if (matchedMasthead.length > 0) {
      //   this.$emit('handleUpdateByMasthead', matchedMasthead[0], this.inputPostcode);
      // } else {
      //   const nearBySuburbs = getNearbySuburbs(this.selectedLocal);
      //   this.$emit('handleUpdateBySuburb', this.selectedLocal, this.inputPostcode, nearBySuburbs);
      // }
      // ******************************************************

      // const nearBySuburbs = getNearbySuburbs(this.selectedLocal);
      this.$emit('handleUpdateBySuburb', this.selectedLocal);

      this.resetInput();
    },

    getRequiredLogo() {
      const selectedProduct = masthead.filter(
        (product) => product.productName === this.globalConfig.productName
      )

      return selectedProduct.length > 0 ? selectedProduct[0].id : '';
    },

    processForm(e) {     
      this.handleSelectLocal(0, e);
    }
  }
}
</script>

<style lang="scss" scoped>
.mylocal__logo {
  height: 26px;
}

.mylocal__logo svg {
  height: 100%;
  width: auto;
}

.mylocal__postcode-container {
  display: flex;
  width: 100%;
  padding: 10px 5px;
  flex-flow: row;

  @media screen and (max-width: 600px) {
    width: 100%;
    max-width: 100%;
    flex-flow: column;
  }
}

.mylocal__branding {
  display: inline-flex;
  font-family: $fontfamily-title-custom;
  text-transform: uppercase;
  margin-left: 10px;
  font-size: 0.8em;

  @media screen and (min-width: 600px) {
    font-size: 1.0em;
  }
}

.mylocal__postcode {
  display: flex;
  flex-flow: row;
  color: #FFFFFF;
  justify-content: space-between;
  padding: 0 5px;
  align-items: center;
  margin: 0;
  height: 60px;
  width: 100%;

  .mylocal__brand-newslocal & {
    background-color: $c-brand-newslocal;
  }

  .mylocal__brand-leader & {
    background-color: $c-brand-leader;
  }

  .mylocal__brand-quest & {
    background-color: $c-brand-questnews;
  }

  .mylocal__brand-messenger & {
    background-color: $c-brand-messenger;
  }
}

.mylocal__postcode-form {
  position: relative;
  display: flex;
  align-items: center;
}

.mylocal__postcode-title {
  font-family: $fontfamily-title-custom;
  font-size: 20px;
  text-transform: uppercase;
  font-weight: bold;
  margin-left: auto;

  @media screen and (max-width: 600px) {
    font-size: 14px;
    margin-left: 0px;
  }
}

.mylocal__postcode-placeholder {
  position: absolute;
  top: 2px;
  right: 0;
  padding-right: 55px;
  font-size: 11px;
  color: #000;
  height: 15px;
  pointer-events: none;
  color: black;  

  @media screen and (min-width: 600px) {
    top: 9px;
    padding-right: 58px;
    font-size: 12px;
  }
}

.mylocal__postcode-placeholder-text {
  line-height: 16px; 
  
  span {
    display: block;
    margin: 0;
  }

  span:nth-child(2) {
    @media screen and (min-width: 600px) {
      display: none;
    }
  }
}

.mylocal__postcode-heading {
  color: #FFF;
  font-size: 18px;
  padding: 0;
  margin: 0;
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: flex-start;
}

.mylocal__postcode-input {
  font-size: 14px;
  height: 35px;
  width: 120px;
  margin: auto;
  margin-left: 5px;
  font-family: $fontfamily-title-custom;
  border-radius: 2px;
  border: 0;
  padding: 10px;
  box-shadow: rgba(35, 35, 35, 0.2) 0px 1px 3px 0px inset;

  &:focus {
    +label {
      display: none;
      color: red;
    }
  }
}

.mylocal__postcode-button {
  cursor: pointer;
  width: 53px;
  height: 35px;
  border-radius: 35px;
  border: 1px solid #FFF;
  margin-left: -25px;
  color: #FFF;
  font-size: 12px;
  background-color: $c-button-blue;

  .mylocal__brand-newslocal & {
    background-color: $c-button-blue;
  }

  .mylocal__brand-quest & {
    background-color: #fbdade;
    color: $c-button-red;
  }

  span {
    display: block;
    margin: auto;
  }
}

.mylocal__postcode-dropdown {
  position: absolute;
  right: 0;
  height: 0;
  bottom: 0;
  width: 100%;
  z-index: 100;
}

.mylocal__postcode-dropdown-list {
  position: absolute;
  top: 10px;
  right: 0;
  margin: 0;
  padding: 0;
  display: inline-flex;
  flex-flow: column;
  list-style-type: none;
  width: max-content;
  color: #000;
  background: #FFF;
  z-index: 1;
  border: 2px solid #000;

  &:before, &:after {
    content: " ";
    position: absolute;
    bottom: 100%;
    left: 85%;
    margin-left: -13px;
    height: 0;
    width: 0;
    border-width: 13px;
    border-style: solid;
    border-image: initial;
    border-color: transparent transparent #000;
  }

  &:after {
    margin-left: -10px;
    border-color: transparent transparent #FFF;
    border-width: 10px;
  }
}

.mylocal__postcode-dropdown-list li {
  margin: 0;
  text-align: left;
  width: auto;
  cursor: pointer;
  background: #FFF;
  border: 1px solid #DADADA;
  font-family: $fontfamily-base-custom;
  font-size: 1.0em;

  &:first-child {
    border: 0;
  }

  a {
    text-decoration: none;
    color: #000;
    display: block;
    padding: 5px;
  }
}

.mylocal__postcode-dropdown-list li:hover {
  background: rgba(0, 0, 0, .2);
}

path {
  fill: #FFF;
}

</style>

